import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from '@mui/material'
import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { IOrganization } from 'types/organization'

interface Props {
  data: IOrganization[]
}

const StyledTable = styled(Table)(() => ({
  borderCollapse: 'collapse',
  width: '100%',
  '& th, & td': {
    border: '1px solid #dddddd !important',
  },
  '& th': {
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  '& .MuiTableCell-root': {
    paddingLeft: '12px',
    paddingRight: '12px',
  },
}))

export const OrganizationTable: FunctionComponent<Props> = ({ data }) => {
  const { t } = useTranslation()

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <StyledTable size="small" sx={{ minWidth: 650, borderCollapse: 'collapse' }}>
          <TableHead>
            <TableRow>
              <TableCell>{t('name')}</TableCell>
              <TableCell>{t('country-code')}</TableCell>
              <TableCell>{t('description')}</TableCell>
              <TableCell>{t('taxId')}</TableCell>
              <TableCell>{t('email')}</TableCell>
              <TableCell>{t('address')}</TableCell>
              <TableCell>{t('phoneNumber')}</TableCell>
              <TableCell>{t('executive-officer-name')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((organization) => (
              <TableRow
                key={organization.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell scope="row">{organization.name}</TableCell>
                <TableCell scope="row">{organization.countryCode}</TableCell>
                <TableCell scope="row">{organization.description}</TableCell>
                <TableCell scope="row">{organization.taxId}</TableCell>
                <TableCell scope="row">{organization.email}</TableCell>
                <TableCell scope="row">{organization.address}</TableCell>
                <TableCell scope="row">{organization.phoneNumber}</TableCell>
                <TableCell scope="row">
                  {organization.executiveOfficerName}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </Paper>
  )
}
